import { Input } from '@advanza/shadcn-ui/src/components/ui/input'
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@advanza/shadcn-ui/src/components/ui/select'
import { Button } from '@advanza/ui'
import { usePopUpNotificationFolders } from 'hooks/popUpnotificationsHooks'
import { useState } from 'react'

export const NO_FOLDER_VALUE = 'none'
const NEW_FOLDER_VALUE = 'new'

interface Props {
    value?: number | null
    onChangeValue: (folderId: number | null) => void
}

const PopUpNotificationFolderSelect = ({ value, onChangeValue }: Props) => {
    const { folders, createFolder } = usePopUpNotificationFolders()
    const [newFolderName, setNewFolderName] = useState<string | null>(null)

    const handleValueChange = (next: string) => {
        if (next === NEW_FOLDER_VALUE) {
            setNewFolderName('')
            return
        }

        onChangeValue(next === NO_FOLDER_VALUE ? null : parseInt(next, 10))
    }

    const handleCreate = async () => {
        if (!newFolderName?.trim()) {
            return
        }

        const folder = await createFolder(newFolderName.trim())
        setNewFolderName(null)

        if (folder) {
            onChangeValue(folder.pop_up_notification_folder_id)
        }
    }

    if (newFolderName !== null) {
        return (
            <div className="flex gap-2">
                <Input
                    autoFocus
                    placeholder="Folder name"
                    value={newFolderName}
                    onChange={(event) => setNewFolderName(event.target.value)}
                />
                <Button name="text" onClick={handleCreate}>
                    Create
                </Button>
                <Button name="text" onClick={() => setNewFolderName(null)}>
                    Cancel
                </Button>
            </div>
        )
    }

    return (
        <Select value={value ? String(value) : NO_FOLDER_VALUE} onValueChange={handleValueChange}>
            <SelectTrigger className="w-full border border-neutral-200 bg-white">
                <SelectValue placeholder="No folder" />
            </SelectTrigger>
            <SelectContent className="bg-white">
                <SelectGroup>
                    <SelectItem value={NO_FOLDER_VALUE}>No folder</SelectItem>
                    {folders.map((folder) => (
                        <SelectItem
                            key={folder.pop_up_notification_folder_id}
                            value={String(folder.pop_up_notification_folder_id)}>
                            {folder.name}
                        </SelectItem>
                    ))}
                    <SelectItem value={NEW_FOLDER_VALUE}>+ New folder…</SelectItem>
                </SelectGroup>
            </SelectContent>
        </Select>
    )
}

export default PopUpNotificationFolderSelect
